







import { Component, Vue,Inject, Prop } from 'vue-property-decorator';
import AbpBase from '../lib/abpbase'
@Component
export default class extends AbpBase {
    name:string= 'breadcrumbNav';
       
    get currentPath() {
        let breadcrumbs = [];

        this.$store.state.app.currentPath.forEach(item => {
            if (item.meta.title != '') {
                let title = item.meta.title;
                if (this.$store.state.company.id > 0 && item.name == 'company' && this.$store.state.company.viewModel != null) 
                    title = this.$store.state.company.viewModel.name;

                breadcrumbs.push({
                    text: title,
                    disabled: false,
                    href: '#' + item.path
                });
            }
        });

        breadcrumbs[breadcrumbs.length - 1].disabled = true;
        return breadcrumbs;
    }
}
